module.exports = __webpack_public_path__ + "static/media/logo-tmp.7eab9104.png";